var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarParent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.645,
    height: 16.763,
    viewBox: "0 0 17.645 16.763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star_-_parent",
    "data-name": "Star - parent",
    transform: "translate(-770.588 -488.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "star_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24",
    d: "M83.375-863.237l1.434-6.2L80-873.6l6.352-.552L88.823-880l2.47,5.845,6.352.552-4.808,4.169,1.434,6.2-5.448-3.286Z",
    transform: "translate(690.588 1368.119)",
    fill: "#072945"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarParent);
export default __webpack_public_path__ + "static/media/Star - parent.802c5ef778ad1e5285006069e6bc149a.svg";
export { ForwardRef as ReactComponent };